import { render, staticRenderFns } from "./AnalyzeSpyderIcon.vue?vue&type=template&id=53bdbecc&scoped=true"
import script from "./AnalyzeSpyderIcon.vue?vue&type=script&lang=js"
export * from "./AnalyzeSpyderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bdbecc",
  null
  
)

export default component.exports